import { render, staticRenderFns } from "./InvoiceNewDocumentDialog.vue?vue&type=template&id=50698fa8&scoped=true"
import script from "./InvoiceNewDocumentDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceNewDocumentDialog.vue?vue&type=script&lang=js"
import style0 from "./InvoiceNewDocumentDialog.vue?vue&type=style&index=0&id=50698fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50698fa8",
  null
  
)

export default component.exports